import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { useEffect, useState } from 'react';

import i18next from '$shared/i18n/i18n';

interface ChatToggleButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

export function ChatToggleButton({ onClick, isOpen }: ChatToggleButtonProps) {
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShake(false);
      return undefined;
    }
    const id = setTimeout(() => setShake(true), 3000);
    return () => clearTimeout(id);
  }, [isOpen]);

  return (
    <button
      id="chatbot-toggle-button"
      type="button"
      onClick={onClick}
      className={`chat-toggle-btn${shake ? ' chat-toggle-btn--shake' : ''}${isOpen ? ' chat-toggle-btn--open' : ''}${isOpen ? ' chat-toggle-btn--mobile-hidden' : ''}`}
      title={
        isOpen
          ? i18next.t('translation:chatbot.closeTitle', 'Close assistant')
          : i18next.t('translation:chatbot.openTitle', 'Ask assistant')
      }
    >
      <Icon
        name="chat-bubble"
        size={IconSizeClasses.XSmall}
        className={`chat-toggle-btn__icon chat-toggle-btn__icon--chat${isOpen ? ' hidden' : ''}`}
      />
      <Icon
        name="close"
        size={IconSizeClasses.XSmall}
        className={`bg-white chat-toggle-btn__icon chat-toggle-btn__icon--close${isOpen ? '' : ' hidden'}`}
      />
      <span className="chat-toggle-btn__label">
        {i18next.t('translation:chatbot.toggleLabel', 'Ask assistant')}
      </span>
    </button>
  );
}
